"use client";

import { trackEvent } from "@pex/analytics/client";
import { useReportWebVitals } from "next/web-vitals";

export function WebVitals() {
  useReportWebVitals((metric) => {
    trackEvent("web_vital", {
      metric_name: metric.name,
      value: Math.round(metric.value),
      rating: metric.rating,
    });
  });
  return null;
}
